import { CustomError, InfoPros, InfoType } from 'interface';
import { create } from 'zustand';


interface InfoStore  {
    info: InfoPros |  null,
    // infoType: InfoType 
    showCustomError: boolean,
    setError: (error: CustomError, showError?: boolean) => void;
    setInfo: (info: InfoPros ) => void;
    resetStore: () => void
}

//Todo: add actual field
export const useInfoStore = create<InfoStore >()((set) => ({
    info:  null,
    showCustomError: false,
    setError: (error: CustomError, showError: boolean = false) => set(() => ({ 
        // infoType: "Error", 
        showCustomError: showError,
        info: {
            infoType: "Error", 
            close: () => set(() => ({ info: null, showCustomError: false })),
            show: true,
            title: error?.title || "Failed",
            description: error?.message || "",
            actions: []
         } })),
    setInfo: (info: InfoPros) => set(() => ({ 
        info:{
            ...info,
            close: () => set(() => ({ info: null, infoType: null })),
        },  })),
    resetStore: () => set(() => ({ info : null, infoType: null })),

}));


export const setError = (error: CustomError) => useInfoStore.getState().setError(error);
export const setInfo = (info: InfoPros) => useInfoStore.getState().setInfo(info);
export const resetStore = () => useInfoStore.getState().resetStore();